export const SINGLE = 'single';
export const TEAM = 'team';
export const ALL = 'all';
